import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=ab8eaf26&scoped=true&"
import script from "./Burger.vue?vue&type=script&lang=ts&"
export * from "./Burger.vue?vue&type=script&lang=ts&"
import style0 from "./Burger.vue?vue&type=style&index=0&id=ab8eaf26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8eaf26",
  null
  
)

export default component.exports